import Vue from 'vue'
import i18n from '@/i18n'
import {isEmail, isLoginAccount, isLoginPWD, isMobile} from '@/utils/validate'

var loginName = (rule, value, callback) => {
  if (!value) {
    return callback(new Error(i18n.t('rule_not_empty'))) // 不能为空
  }
  if (isLoginAccount(value)) {
    callback()
  } else {
    callback(new Error('支持数字或字母6-12位'))
  }
}

var password = (rule, value, callback) => {
  if (!value) {
    return callback(new Error(i18n.t('rule_not_empty'))) // 不能为空
  }
  if (isLoginPWD(value)) {
    callback()
  } else {
    callback(new Error('8-16位数字大小写字母组合'))
  }
}

// 手机号验证
var mobile = (rule, value, callback) => {
  if (!value) {
    return callback(new Error(i18n.t('rule_not_empty'))) // 不能为空
  }
  if (!isMobile(value)) {
    callback(new Error(i18n.t('rule_mobile'))) // 请输入正确手机号
  } else {
    callback()
  }
}
//数字验证
var number = (rule, value, callback) => {
  if (!value) {
    return callback(new Error(i18n.t('rule_not_empty'))) // 不能为空
  }
  if (!Number.isInteger(value)) {
    callback(new Error(i18n.t('rule_number'))) // 请输入数字值
  } else {
    if (value < 18) {
      callback(new Error('必须大于18岁'))
    } else if (value > 55) {
      callback(new Error('必须小于55岁'))
    } else {
      callback()
    }
  }
}
//text不能为空
var text = (rule, value, callback) => {
  if (!value) {
    return callback(new Error(i18n.t('rule_not_empty'))) // 不能为空
  } else {
    callback()
  }
}
//desc不能为空
var desc = (rule, value, callback) => {
  if (!value) {
    return callback(new Error(i18n.t('rule_not_empty'))) // 不能为空
  } else {
    callback()
  }
}
//邮箱
var email = (rule, value, callback) => {
  if (!value) {
    return callback(new Error(i18n.t('rule_not_empty'))) // 不能为空
  }
  if (!isEmail(value)) {
    callback(new Error(i18n.t('rule_email'))) // 请输入正确邮箱
  } else {
    callback()
  }
}
//开始时间
var startTime = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请选择开始时间'))
  } else {
    callback()
  }
}
//开始时间
var endTime = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请选择结束时间'))
  } else {
    callback()
  }
}
//时间
var time = (rule, value, callback) => {
  if (!value) {
    return callback(new Error(i18n.t('rule_date'))) // 请选择日期
  } else {
    callback()
  }
}
// 年与日小时分钟秒
var datetime = (rule, value, callback) => {
  if (!value.length) {
    return callback(new Error(i18n.t('rule_date'))) // 请选择日期
  } else {
    callback()
  }
}
//多选框
var checkbox = (rule, value, callback) => {
  if (value === null || value === undefined || value === '' || value && value.length < 1) {
    return callback(new Error(i18n.t('rule_select'))) // 请选择一个
  } else {
    callback()
  }
}
//单选框
var radio = (rule, value, callback) => {
  if (value.length < 1) {
    return callback(new Error(i18n.t('rule_select'))) // 请选择一个
  } else {
    callback()
  }
}
//下拉框
var select = (rule, value, callback) => {
  if (value === null || value === undefined || value === '' || value && value.length < 1) {
    return callback(new Error(i18n.t('rule_select')))
  } else {
    callback()
  }
}
//QQ号码验证
var QQV = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('输入QQ号'))
  } else if (/^[1-9][0-9]{4,10}$/.test(value)) {
    callback()
  } else {
    callback(new Error('输入正确的QQ号'))
  }
}

// 最多2位小数
function checkNumPot2(rule, value, callback) {
  const reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/
  if (!value) {
    return callback(new Error(i18n.t('rule_number'))) // 请填写数字
  } else if (!reg.test(value)) {
    return callback(new Error(i18n.t('rule_number_pot'))) // 请填写数字,最多2位小数
  } else {
    callback()
  }
}

// 最多6位小数
function checkNumPot6(rule, value, callback) {
  const reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,6})?$/
  if (!value) {
    return callback('请填写数字') // 请填写数字
  } else if (!reg.test(value)) {
    return callback('请填写数字,最多6位小数')
  } else {
    callback()
  }
}

// 身份证
function checkIdNum(rule, value, callback) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  if (!value) {
    return callback(new Error(i18n.t('rule_id_number_empty'))) // 证件号码不能为空
  } else if (!reg.test(value)) {
    return callback(new Error(i18n.t('rule_id_number_error'))) // 证件号码不正确
  } else {
    callback()
  }
}

// 整数
function checkInterNum(rule, value, callback) {
  const reg = /^[1-9][0-9]*$/
  if (!value) {
    return callback(new Error(i18n.t('rule_int_number'))) // 请输入整数
  } else if (!reg.test(value)) {
    return callback(new Error(i18n.t('rule_int_number'))) // 请输入整数
  } else {
    callback()
  }
}

const confirmPasswordValidator = (rule, value, callback, password) => {
  if (password !== value) {
    callback(new Error(i18n.t('rule_confirm_password'))) // 两次密码输入不一致
  } else {
    callback()
  }
}

const confirmNewPwdValidator = (rule, value, callback, password) => {
  if (password === value) {
    callback(new Error('新密码与旧密码不能相同'))
  } else {
    callback()
  }
}

const formRules = {
  QQ: [{ required: true, validator: QQV, trigger: 'blur' }],
  code: [{ required: true, pattern: /^[0-9]{4,6}$/, message: i18n.t('rule_code'), trigger: 'blur' }], // 手机验证码
  mobile: [{
    required: true,
    pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
    message: i18n.t('rule_zh_mobile'),
    trigger: 'blur'
  }], // 目前只支持中国大陆的手机号码
  phone: [{
    required: true,
    pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$|^0\d{2,3}-\d{7,8}$/,
    message: '请输入有效的联系方式',
    trigger: 'blur'
  }], // 目前只支持中国大陆的手机号码
  loginName: [{ required: true, validator: loginName, trigger: ['change', 'blur'] }],
  email: [{ required: true, validator: email, trigger: ['change', 'blur'] }],
  password: [{ required: true, validator: password, trigger: ['change', 'blur'] }], // 长度必须大于8位长度在 8 到 16 个字符之间
  newPwd: (form) => {
    return [
      { required: true, validator: password, trigger: ['change', 'blur'] },
      {
        required: true,
        validator: (rule, value, callback) => confirmNewPwdValidator(rule, value, callback, form.oldPwd),
        trigger: 'blur'
      }
    ]
  },
  confirmPassword: (form) => {
    return [
      { required: true, validator: password, trigger: ['change', 'blur'] },
      {
        required: true,
        validator: (rule, value, callback) => confirmPasswordValidator(rule, value, callback, form.newPwd),
        trigger: 'blur'
      }
    ]
  },
  required: [{required: true, min: 1, message: i18n.t('form_rules_required'), trigger: 'blur'}], // 必填
  requiredMin2Max10: [{required: true, min: 2, max: 10, message: '限制2-10个字', trigger: 'blur'}], // 必填
  requiredMin2Max20: [{required: true, min: 2, max: 20, message: '限制2-20个字', trigger: 'blur'}], // 必填
  requiredMin3Max5: [{required: true, min: 3, max: 5, message: '限制3-5个字', trigger: 'blur'}], // 必填
  numPot2: [{required: true, validator: checkNumPot2, trigger: 'blur'}],
  numPot6: [{required: true, validator: checkNumPot6, trigger: 'blur'}],
  InterNum: [{required: true, validator: checkInterNum, trigger: 'blur'}],
  coins: [{required: true, validator: checkInterNum, trigger: 'blur'}],
  tags: [{type: 'array', required: true, message: i18n.t('form_rules_required'), trigger: ['change', 'blur']}],
  uploadImgs: [{type: 'array', required: true, message: i18n.t('rule_upload_imgs'), trigger: ['change', 'blur']}], // 请选择图片
  uploadDoc: [{type: 'array', required: true, message: '请选择文件', trigger: ['change', 'blur']}],
  time: [{required: true, validator: time, trigger: ['change', 'blur']}],
  startTime: [{required: true, validator: startTime, trigger: ['change', 'blur']}],
  endTime: [{required: true, validator: endTime, trigger: ['change', 'blur']}],
  datetime: [{required: true, validator: datetime, trigger: ['change', 'blur']}],
  select: [{required: true, validator: select, trigger: 'change'}],
  checkbox: [{required: true, validator: checkbox, trigger: ['change']}],
  roleName: [{required: true, message: '请输入角色名称', trigger: 'blur'}],
  roleCode: [{required: true, message: '请选择角色类型', trigger: 'change'}],
  orgId: [{required: true, message: '请选择组织', trigger: 'change'}],
  orgName: [{required: true, message: '请输入组织名称', trigger: 'blur'}],
  orgType: [{required: true, message: '请选择组织类型', trigger: 'change'}],
  orgCategory: [{required: true, message: '请选择组织类别', trigger: 'change'}],
  areaId: [{required: true, message: '请选择行政区划', trigger: 'change'}],
  areaIdsMin3: [{type: 'array', min: 3, required: true, message: '请选择到区级以下', trigger: 'change'}],
  // 选项不可被重复选择
  notRepeatTheSelection: (form, errorMessage) => {
    return [
      {required: true, validator: select, trigger: 'change'},
      {
        required: true,
        validator: (rule, value, callback) => {
          const field = rule.field.split('.')
          const formKey = field[0]
          const index = +field[1]
          const arr = form[formKey].map(item => item[field[2]])
          const idx = arr.findIndex(item => JSON.stringify(item) === JSON.stringify(arr[index]))

          // 下标相等且数据相等
          if (index !== idx) {
            callback(new Error(errorMessage || '值有重复'))
          } else {
            callback()
          }
        },
        trigger: ['change', 'blur']
      }
    ]
  },
  // 选项不可被重复选择
  orgnotRepeatTheSelection: (form, errorMessage) => {
    return [
      { required: true, validator: select, trigger: 'change' },
      {
        required: true,
        validator: (rule, value, callback) => {
          const field = rule.field.split('.')
          const formKey = field[0]
          const index = +field[1]
          const arr = form[formKey].map(item => item[field[2]])
          const idx = arr.findIndex(item => JSON.stringify(item) === JSON.stringify(arr[index]))
          const arr1 = form[formKey].map(item => item['orgId'])[form[formKey].map(item => item['orgId']).length - 1]
          form[formKey].map(item => {
            item.orgIds = item.orgId[item.orgId.length - 1]
            if (index !== idx && item.orgIds === arr1[arr1.length - 1]) {
              callback(new Error(errorMessage || '值有重复'))
            } else {
              callback()
            }
          })
        },
        trigger: ['change', 'blur']
      }
    ]
  }
}

Vue.prototype.formRules = formRules
